import React, { Component } from "react";
import { Table } from "reactstrap";
import _ from "lodash";
import { formatNumber } from "../../utils/utils";
class PrimaryOfftakeSummary extends Component {
  offTakeSummary = {};
  getStripedStyle(index) {
    return { background: index % 2 === 0 ? "#f6f6f6" : "white" };
  }
  sumCol(col) {}
  render() {
    this.offTakeSummary = this.props.offTakeSummary;
    let totalPoints = 0;
    let totalBalance = 0;
    if (this.offTakeSummary && this.offTakeSummary.pointsSummary) {
      totalPoints = _.sumBy(this.offTakeSummary.pointsSummary, function(item) {
        return item.points;
      });
    }
    if (this.offTakeSummary && this.offTakeSummary.pointsSummary) {
      totalBalance = _.sumBy(this.offTakeSummary.pointsSummary, function(item) {
        return item.balance;
      });
    }
    return (
      <>
        <div className="quarter-points-wrapp">
          <div className="quarter-points-inner">
            <div className="d-flex-column">
              {/* <span className="Total-Earned-Points">
                Total Earned Points{" "}
                <b>{formatNumber(this.props.totalEarnedPoints)}</b>
              </span>
              <span className="Till-Date mb-2 mt-2">Till Date</span> */}
              <div className="QUARTER-table quarter-tbl-left">
                <Table
                  className="mb-0 table-responsive tbl-offtake-summary"
                  bordered
                  style={{ border: "none" }}
                >
                  <thead>
                    <tr style={{ ...this.getStripedStyle(0) }}>
                      <th className="offtake-tbl-th">Description</th>
                      <th className="offtake-tbl-th text-align-center">
                        Points
                      </th>
                    </tr>
                  </thead>
                  {
                    <tbody>
                      {this.offTakeSummary.pointsSummary.map((item, i) =>
                        item.label === "Opening balance" &&
                        item.points === 0 ? (
                          ""
                        ) : (
                          <tr style={{ ...this.getStripedStyle(i + 1) }}>
                            <td className="text-align-left">{item.label}</td>
                            <td className="text-align-center">
                              {formatNumber(item.points)}
                            </td>
                          </tr>
                        )
                      )}
                      {this.offTakeSummary.pointsSummary &&
                        this.offTakeSummary.pointsSummary.length > 0 && (
                          <tr style={{ backgroundColor: "#efefef" }}>
                            <th>Total</th>
                            <td className="text-align-center">
                              {formatNumber(totalPoints)}
                            </td>
                          </tr>
                        )}
                    </tbody>
                  }
                </Table>
                {this.offTakeSummary.isNoDataFound && (
                  <div className="no-data tbl-offtake-summary">
                    Currently, there is no points.
                  </div>
                )}
              </div>
              <br />
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default PrimaryOfftakeSummary;
